module.exports = new __parcel__URL__("monkey.423f2177.svg").toString();